import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostLimitAlertsFetched, {
	type AiCostLimitAlertPayload,
	type AiCostLimitAlertsFetchedAction,
} from '@Application/AiCostLimits/Alerts/Actions/aiCostLimitAlertsFetched';
import aiCostLimitAlertsFetchFailed, {
	type AiCostLimitAlertsFetchFailedAction,
} from '@Application/AiCostLimits/Alerts/Actions/aiCostLimitAlertsFetchFailed';
import type FetchAiCostLimitAlerts from '@Application/AiCostLimits/Alerts/Queries/FetchAiCostLimitAlerts';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitAlertsFetchedAction | AiCostLimitAlertsFetchFailedAction;

export default (query: FetchAiCostLimitAlerts) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiCostLimitAlertPayload[]>(
				`${parameters.api.host}/api/accounts/${query.accountId}/ai-cost-limit-alerts`,
			);

			const action = aiCostLimitAlertsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitAlertsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
